<template>
    <div v-if="show" class="position-fixed p-3 border-radius-5 bg-success-light border border-success text-success d-flex align-items-center transition" style="left: 20px; bottom: 20px;">
        <div>
            {{ message }}
        </div>
        <div class="ml-2">
            <i class="fal fa-times cursor-pointer" @click="show = false;"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: 'Succes',
        },
    },
    data () {
        return {
            show: true,
        };
    },
    mounted () {
        setTimeout(() => {
            this.show = false;
        }, 4000);
    },
};
</script>
